import { jsx } from 'react/jsx-runtime';
import { twMerge } from '@belong/common/twMerge';

function ActiveTabIndicator({
  activeRect,
  rect,
  color
}) {
  if (!rect || !activeRect) {
    return null;
  }
  const {
    bottom: activeRectBottom,
    left: activeRectLeft,
    width: activeRectWidth
  } = activeRect;
  const {
    left: rectLeft,
    top: rectTop
  } = rect;
  const left = activeRectLeft - rectLeft;
  const top = activeRectBottom - rectTop;
  return jsx("div", {
    className: twMerge('absolute h-2xs rounded ease-out transition-all duration-hover', color),
    style: {
      left,
      top,
      width: activeRectWidth
    }
  });
}

export { ActiveTabIndicator };
